<template>
  <div>
    <div class="semitransp">
      <b-jumbotron bg-variant="transparent" text-variant="white" class="border-top border-bottom border-warning">
        <template v-slot:header>Opções Pergamin</template>
      </b-jumbotron>
    </div>

    <div class="semitransp">
      <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
        <template v-slot:lead>Características gerais dos sistemas Pergamin</template>
        <hr class="my-4" />
        <div class="espacada text-left">
          <p>Um dos grandes diferenciais dos sistemas Pergamin é a organização original da tela do usuário, em forma de pergaminho, que deu origem ao nome Pergamin. Ao rolar para cima ou para baixo, na tela do sistema, podem ser vistas todas as tarefas disponíveis e acumuladas. O colaborador vê uma lista de atividades, que é intuitiva e simples de utilizar.</p>
          <p>Os sistemas Pergamin são totalmente online, e não exigem a instalação de nenhum programa exceto um navegador de internet compatível. Apesar disso, também podem ser utilizados em sistema de intranet, com servidor local.</p>
          <p>Todos os sistemas Pergamin contam com o suporte personalizado e atencioso dos desenvolvedores, Lucchese Computação e Estatística.</p>
        </div>
      </b-jumbotron>
    </div>

    <div class="semitransp">
      <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
        <template v-slot:lead>Pergamin Organic</template>
        <hr class="my-4" />
        <div class="espacada text-left">
          <p>Inicialmente desenvolvido para clínicas e hospitais, o Organic tem funções importantes para estes negócios, tais como interoperabilidade com equipamento médico, marcação de exames facilitada, e auxílio no preenchimento de laudos.</p>
          <p>Porém, pode ser implantado para outros negócios, principalmente aqueles que envolvem serviços e atendimento ao público, ou que exigem processos realizados por diferentes profissionais na cadeia de produção.</p>
          <p>Pode ser contratado para implantação imediata e hospedagem em servidor compartilhado.</p>
          <p>Trabalhamos também com adaptações e personalizações no sistema, ou caso se deseje um estado de alta disponibilidade, com servidores locais e hospedados em outro local (nuvem) simultaneamente.</p>
          <!--<p>Atualmente, está implementado em uma clínica muito conceituada de Porto Alegre - RS.</p>-->
          <p>Em geral, trabalhamos com pagamentos mensais, e extras eventuais por personalizações e desenvolvimento web, se for o caso. Nossos valores são acessíveis e nós oferecemos um bom custo-benefício aos nossos clientes. Além disso, as condições de pagamento podem ser negociadas.</p>
        </div>
      </b-jumbotron>
    </div>

     <div class="semitransp">
      <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
        <template v-slot:lead>Pergamin nfpoa</template>
        <hr class="my-4" />
        <div class="espacada text-left">
          <p>Se destina a contabilistas e empresas, com um ou mais usuários.</p>
          <p>Com o sistema Pergamin nfpoa, você cria, registra na Prefeitura, imprime e envia Notas Fiscais, gera guias para pagamento dos impostos federais e até a Escrituração Fiscal Digital (EFD), tudo através da internet.</p>
          <p>Sua tecnologia exclusiva dispensa a instalação do seu certificado digital ou de qualquer programa no seu computador. Pode ser usado também em tablets e smartphones.</p>
          <p>Antes de emitir cada Nota Fiscal, você pode utilizar o modo de Simulação, que testa inclusive a transmissão para a Prefeitura, e ver exatamente como a Nota vai ficar.</p>
          <p>Os dados das Notas Fiscais ficam armazenados, e você pode aproveitá-los como modelo para novas Notas. Inclusive as suas Notas Fiscais emitidas por outros meios (papel, site da Prefeitura), podem ser registradas no sistema.</p>
          <p>
            O cálculo, totalização de impostos, geração de Guias de Pagamento (DARFs) e geração de arquivo de EFD para transmissão à Receita Federal é automático.
            Cadastro de clientes, compartilhado entre as filiais da empresa, e cadastro prévio de serviços, agilizam o preenchimento de novas Notas Fiscais.
            E muitas outras facilidades, como ver resumo de Notas Fiscais em smartphones via código QR.
          </p>
          <p>Baixo custo mensal, inclusive para quem tem pouca quantidade de Notas Fiscais a emitir.</p>
          <p>Visite o<a href="https://nf.poa.br" class="linkpergamin"> site do Pergamin nfpoa</a>!</p>
        </div>
      </b-jumbotron>
    </div> 

    <div class="semitransp">
      <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
        <template v-slot:lead>Agradecemos seu interesse nas soluções Pergamin!</template>
        <hr class="my-4" />
        <div class="fininha text-left">
          <p>Solicite um orçamento, sem compromisso, ou entre em contato conosco para mais informações.</p>
          <ValidationObserver ref="observer">
            <!--@submit="onSubmit" @reset="onReset" v-if="show" 
        <b-form-invalid-feedback>
          {{ errors[0] }}
            </b-form-invalid-feedback>-->
            <b-form
              slot-scope="{ validate }"
              @submit.prevent="validate().then(onSubmit)"
              @reset="onReset"
            >
              <ValidationProvider rules="required|alpha_spaces" name="Name">
                <b-form-group
                  id="input-group-1"
                  label="Nome*:"
                  label-for="input-1"
                  slot-scope="{ valid, errors }"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.name"
                    required
                    placeholder="Seu nome"
                    :state="errors[0] ? false : (valid ? true : null)"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>

              <ValidationProvider rules="required|email" name="Email">
                <b-form-group
                  id="input-group-2"
                  label="E-mail*:"
                  label-for="input-2"
                  slot-scope="{ valid, errors }"
                >
                  <b-form-input
                    id="input-2"
                    v-model="form.email"
                    type="email"
                    required
                    placeholder="Endereço de e-mail"
                    :state="errors[0] ? false : (valid ? true : null)"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>

              <ValidationProvider rules="alpha_num" name="Telefone">
                <b-form-group
                  id="input-group-3"
                  label="Telefone:"
                  label-for="input-3"
                  slot-scope="{ valid, errors }"
                >
                  <!-- description="."> -->
                  <b-form-input
                    id="input-3"
                    v-model="form.tel"
                    type="tel"
                    placeholder="Telefone"
                    :state="errors[0] ? false : (valid ? true : null)"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>

              <b-form-group
                id="input-group-5"
                label-for="input-5"
                label="Sistema Pergamin*:"
                required
              >
                <b-form-radio v-model="form.porque" name="select2" value="ORG">Pergamin Organic</b-form-radio>
                 <b-form-radio v-model="form.porque" name="select2" value="NSF">Pergamin nfpoa</b-form-radio> 
                <b-form-radio v-model="form.porque" name="select2" value="OUT">Outros</b-form-radio>
              </b-form-group>

              <ValidationProvider rules="required|alpha_spaces|max:100" name="AssuntoTexto">
                <b-form-group
                  id="input-group-6"
                  label="Assunto*:"
                  label-for="input-6"
                  slot-scope="{ valid, errors }"
                >
                  <b-form-input
                    required
                    id="input-6"
                    v-model="form.assunto"
                    type="text"
                    placeholder="Assunto do seu contato"
                    :state="errors[0] ? false : (valid ? true : null)"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>

              <!-- <b-form-group id="input-group-7"  label="Texto*:" label-for="input-7">
        <b-form-input
          required
          id="input-7"
          v-model="form.text"
          type="text"
          placeholder="Texto"
        ></b-form-input>
              </b-form-group>-->
              Texto*:
              <ValidationProvider rules="required|max:1000" name="TextoTexto">
                <b-form-textarea
                  slot-scope="{ valid, errors }"
                  id="textarea"
                  v-model="form.text"
                  placeholder="Máximo: 1000 caracteres"
                  rows="3"
                  max-rows="6"
                  required
                  :state="errors[0] ? false : (valid ? true : null)"
                ></b-form-textarea>
              </ValidationProvider>
              <div class="espacador"></div>

              <vue-recaptcha
                ref="recaptcha"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
                sitekey="6Lf8LsIZAAAAAMqD80l1J4ghrhHn2e_Mzo8APmZS"
                size="invisible"
              ></vue-recaptcha>

              <b-row>
                <b-col class="text-center">
                  <b-button :disabled="sending" type="submit" variant="outline-light">Enviar</b-button>
                </b-col>
                <b-col class="text-center">
                  <b-button type="reset" variant="outline-light">Limpar</b-button>
                </b-col>
              </b-row>
            </b-form>
          </ValidationObserver>
          <!--- 
          <b-card class="mt-3" header="Form Data Result">
            <pre class="m-0">{{ form }}</pre>
          </b-card>-->
        </div>
      </b-jumbotron>
    </div>

    <b-button size="lg" to="/" variant="outline-light">Voltar à página inicial</b-button>
    <div class="espacador"></div>
    <div class="barracor">
      <p class="text-center barra">Lucchese Computação e Estatística Ltda. &copy; 2020</p>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueRecaptcha from "vue-recaptcha";
import api from "../services/api";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    VueRecaptcha,
  },
  data() {
    return {
      form: {
        email: "",
        name: "",
        tel: "",
        text: "",
        assunto: "",
        //ligacao: "",
        porque: "",
      },
      show: true,
      sending: false
    };
  },
  methods: {
    onSubmit() {
      this.sending = true;
      this.$refs.recaptcha.execute();
      //console.log(JSON.stringify(this.form));
      //alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.tel = "";
      this.form.text = "";
      this.form.assunto = "";
      this.form.porque = "";
      //this.form.ligacao = ""
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    onCaptchaVerified: function (recaptchaToken) {
      this.$refs.recaptcha.reset();
      api
        .post("/sitemailer/", {
          email: this.form.email,
          name: this.form.name,
          tel: this.form.tel,
          porque: this.form.porque,
          assunto: this.form.assunto,
          text: this.form.text,
          recaptchaToken: recaptchaToken,
        })
        .then((response) => {
          this.sending=false;
          if(response.status==200){
            alert("Sua mensagem foi enviada com sucesso! Aguarde nosso contato em breve.");
          }else{
            alert("Houve algum erro ao enviar sua mensagem. Por favor, tente novamente.");
          }
        })
        .catch((err) => {
          this.sending=false;
          alert("Houve algum erro ao enviar sua mensagem. Por favor, tente novamente.");
          console.log(err);
        });
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
  },
};
</script>

<style scoped>
body {
  background-image: url("../assets/background.jpg");
  background-attachment: fixed;
}
.barracor {
  background: rgba(0, 0, 0, 0.8);
}
.barra {
  color: white;
}

.botaoenviar {
  padding-right: 1rem;
}

.fininha {
  padding-left: 20vw;
  padding-right: 20vw;
}

.linkpergamin {
  color: gold;
}
</style>